var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"p-3"},[_vm._v(_vm._s(_vm.$t("products.name")))]),_vm._l((_vm.products),function(dir){return _c('Product',{key:dir.name,attrs:{"obj":dir}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }